import React from 'react';
import { motion } from 'framer-motion';

const ThousandAlumni = (props) => {
    const { isSmallScreen } = props;

    const distributions = [
        { header: "1,00,000+", subHeader: "Learners Have Trusted Us" },
        { header: "50%", subHeader: "Average Salary Hike" },
        { header: "97%", subHeader: "Happy with Outcome" },
    ];

    return (
        <motion.div
            style={{
                width: '100%',
                backgroundColor: '#F8EFFF',
                padding: '1rem 0',
                margin: "3rem 0"
            }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: isSmallScreen ? 'column' : 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: isSmallScreen ? '1rem' : '3rem',
                    width: '100%',
                    margin: '0 auto',
                    padding: isSmallScreen ? '0 1rem' : '0'
                }}
            >
                {distributions.map((dist, index) => (
                    <motion.div
                        key={index}
                        style={{
                            textAlign: 'center',
                            width: isSmallScreen ? '100%' : '180px'
                        }}
                        whileHover={{ scale: isSmallScreen ? 1.2 : 1.5 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <h2 style={{
                            fontSize: isSmallScreen ? "20px" : "28px",
                            margin: 0,
                            fontFamily: "Poppins",
                        }}>
                            {dist.header}
                        </h2>

                        <p style={{
                            fontSize: isSmallScreen ? "10px" : "14px",
                            marginTop: "5px"
                        }}>
                            {dist.subHeader}
                        </p>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

export default ThousandAlumni;